import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Idea"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M8.2497 18H15.7497V19.5H8.2497V18ZM9.7497 21H14.2497V22.5H9.7497V21ZM11.9997 1.5C7.85752 1.5 4.49965 4.85786 4.49965 9C4.39676 11.2112 5.36213 13.3372 7.09465 14.715C7.84465 15.4125 8.24965 15.81 8.24965 16.5H9.74965C9.74965 15.12 8.91715 14.3475 8.10715 13.605C6.68379 12.515 5.89418 10.7897 5.99965 9C5.99965 5.68629 8.68595 3 11.9997 3C15.3134 3 17.9997 5.68629 17.9997 9C18.1034 10.791 17.3108 12.5166 15.8847 13.605C15.0822 14.355 14.2497 15.105 14.2497 16.5H15.7497C15.7497 15.81 16.1472 15.4125 16.9047 14.7075C18.636 13.3321 19.6013 11.2088 19.4997 9C19.4997 7.01088 18.7095 5.10322 17.303 3.6967C15.8964 2.29018 13.9888 1.5 11.9997 1.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Idea.vue"]]);
